// import React, { useEffect, useRef, useState } from "react";
// import {
//   addOverviewCourse,
//   getCourseCategories,
//   getCourses,
//   getOverviewCourses,
//   updateCollegeDetails,
// } from "../../../Services/HomeService";
// import toast from "react-hot-toast";
// import 'react-quill/dist/quill.snow.css';
// import ReactQuill from "react-quill";
// import { useSelector } from "react-redux";

// const modules = {
//   toolbar: [
//     [{ header: [1, 2, false] }],
//     ["bold", "italic", "underline", "strike", "blockquote"],
//     [{ list: "ordered" }, { list: "bullet" }],
//     ["link"],
//     ["clean"],
//   ],
// };

// const CollegeUniversityStep3 = ({ data, setData, setCurrentStep, currentStep }) => {

//   const initialValues = {
//     collegeId: data?._id,
//     overviewCourse: data?.overviewCourse
//   }
//   const [formData, setFormData] = useState(initialValues);
//   const [formDataLoading, setFormDataLoading] = useState(false);

//   const handleBack = (e) => {
//     e?.preventDefault();
//     setCurrentStep(currentStep - 1)
//   }

//   const handleUpdate = async (e) => {
//     e?.preventDefault();
//     console.log("CDE40", formData);

//     // return
//     try {
//       setFormDataLoading(true);
//       const res = await addOverviewCourse(formData);
//       console.log("College Add Step2 Message ", res);
//       if (res?.status) {
//         // toast.success(res?.message);
//         setFormData(initialValues)
//         setFormDataLoading(false);
//         // setData({
//         //   ...data,
//         //   internshipHeading: formData?.internshipHeading,
//         //   placementText: formData?.placementText,
//         //   overviewCourse: formData?.overviewCourse
//         // })
//         setCurrentStep(currentStep)
//       } else {
//         toast.error(res?.message);
//         setFormDataLoading(false);
//       }
//     } catch (error) {
//       toast.error("Failed to add College.");
//       console.error("Error adding College:", error);
//       setFormDataLoading(false);
//     }
//   };

//   //// Course & Category /////
//   const [courseCategories, setCourseCategories] = useState([]);
//   const [courses, setCourses] = useState([]);

//   const fetchCourseCategories = async () => {
//     try {
//       const res = await getCourseCategories();
//       console.log("fetched Course Categories", res?.data);
//       if (res?.status) {
//         setCourseCategories(res?.data);
//       } else {
//         toast.error("Error while Fetching Course Categories Data");
//       }
//     } catch (error) {
//       toast.error("failed to fetch Course Categories Data");
//       console.error("Error fetching Course Categories:", error);
//     }
//   };

//   const fetchCourses = async (categoryId) => {
//     try {
//       const res = await getCourses();
//       console.log("fetched Courses", res?.data);
//       if (res?.status) {
//         const retVal = res?.data.filter(item => item.categoryId === categoryId)
//         return retVal
//         // setCourses(val);
//       } else {
//         toast.error("Error while Fetching Courses Data");
//       }
//     } catch (error) {
//       toast.error("failed to fetch Courses Data");
//       console.error("Error fetching Courses:", error);
//     }
//   };

//   const fetchOverviewCourses = async (collegeId) => {
//     try {
//       const res = await getOverviewCourses(collegeId);

//       if (res?.status) {

//         const restructured = {
//           overviewCourse: res?.data.map(item => ({
//             courseCategory: item.courseCategory._id,
//             courseDegree: item.courseDegree._id,
//             eligibilityCriteria: item.eligibilityCriteria
//           }))
//         };
//         console.log("CDG118", restructured);
//       } else {
//         toast.error("Error while Fetching Courses Data");
//       }
//     } catch (error) {
//       console.error("Error fetching Courses:", error);
//     }
//   };

//   /////////////////////////////////////
//   const initialItem = {
//     courseCategory: "",
//     courseDegree: "",
//     eligibilityCriteria: "",
//   };
//   const [courseList, setCourseList] = useState([])

//   const initialItems = data?.overviewCourse?.length ? data?.overviewCourse : [initialItem]
//   // console.log("LKI124", initialItems);

//   const [items, setItems] = useState(initialItems);
//   const handleMultiChange = async (i, e) => {
//     let newFormValues = [...items];
//     newFormValues[i][e.target.name] = e.target.value;
//     setItems(newFormValues);
//     setFormData({ ...formData, overviewCourse: newFormValues })

//     if (e.target.name === "courseCategory") {
//       const courseOptions = await fetchCourses(e.target.value)
//       console.log("MJY117", courseOptions);
//       if (courseList.length > i) {
//         setCourseList(prev => {
//           const updated = [...prev];
//           updated[i] = courseOptions;
//           return updated;
//         });
//       } else {
//         setCourseList([...courseList, courseOptions])
//       }
//     }

//   };

//   const addItem = () => {
//     if (items?.length < 5000) {
//       setItems([...items, initialItem]);
//     }
//   };

//   const removeProducts = (i) => {
//     let newFormValues = [...items];
//     newFormValues.splice(i, 1);
//     setItems(newFormValues);
//     setFormData({ ...formData, overviewCourse: newFormValues })
//   };

//   const populateCourseOptions = async () => {
//     try {
//       const res = await getCourses();
//       console.log("fetched Courses", res?.data);
//       if (res?.status) {
//         // setCourses(res?.data);
//         const allAvailableCourses = res?.data
//         console.log("DER188", allAvailableCourses, initialItems);
//         initialItems.map((item, i) => {
//           const courseCategoryId = item?.courseCategory || item?.courseCategory?._id
//           console.log("CDE181", allAvailableCourses, courseCategoryId);

//           const courseOptions = allAvailableCourses.filter(c => c.categoryId === courseCategoryId)
//           console.log("CDE167", courseOptions, i);
//           setCourseList(prev => {
//             const updated = [...prev];
//             updated[i] = courseOptions;
//             return updated;
//           });
//         })
//       } else {
//         toast.error("Error while Fetching Courses Data");
//       }
//     } catch (error) {
//       toast.error("failed to fetch Courses Data");
//       console.error("Error fetching Courses:", error);
//     }
//   };

//   console.log("KIU215", courseList);

//   ///// ***** ////
//   useEffect(() => {
//     fetchCourseCategories()
//     populateCourseOptions()
//   }, [])

//   useEffect(() => {
//     setFormData(initialValues)
//   }, [data])

//   useEffect(() => {
//     data?._id && fetchOverviewCourses(data?._id)
//   }, [data])

//   return (
//     <>

//       <section className="chartBox_area">
//         <form
//           onSubmit={(e) => {
//             handleUpdate(e);
//           }}
//         >
//           <div className="row d-flex justify-content-center">

//             <div className="col-md-12 mt-3">
//               <label>
//                 Eligibility <button
//                   className="btn btn-sm btn-success"
//                   type="button"
//                   onClick={() => addItem()}
//                 >
//                   <i class="fas fa-plus"></i> Add Course
//                 </button>
//               </label>
//               {items?.map((element, index) => (

//                 <div
//                   // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
//                   className="_form-inline row" key={index}>

//                   <div className="col-md-2 mb-2 mt-1">
//                     <label>
//                       Category:
//                     </label>
//                     <select
//                       name="courseCategory"
//                       onChange={(e) => handleMultiChange(index, e)}
//                       value={element?.courseCategory}
//                       className="form-control"
//                     >
//                       <option value="">--- Choose ---</option>
//                       {
//                         courseCategories.map((e, i) => {
//                           return (
//                             <option key={i} value={e?._id}>
//                               {e?.name}
//                             </option>
//                           )
//                         }
//                         )}
//                     </select>
//                   </div>

//                   <div className="col-md-3 mb-2 mt-1">
//                     <label>
//                       Course:
//                     </label>
//                     <select
//                       name="courseDegree"
//                       onChange={(e) => handleMultiChange(index, e)}
//                       value={element?.courseDegree}
//                       className="form-control"
//                     >
//                       <option value="">--- Choose ---</option>
//                       {
//                         courseList[index]?.map((e, i) => {
//                           return (
//                             <option key={i} value={e?._id}>
//                               {e?.degreeName}
//                             </option>
//                           )
//                         }
//                         )}
//                     </select>
//                   </div>

//                   <div className="col-md-7 mb-2 mt-1">
//                     <label>
//                       Eligibility:
//                     </label>
//                     <input
//                       type="text"
//                       class="form-control"
//                       name="eligibilityCriteria"
//                       placeholder={`Eligibility criteria`}
//                       value={element.eligibilityCriteria || ""}
//                       onChange={(e) => handleMultiChange(index, e)}
//                     />
//                   </div>

//                   {index ? (
//                     <div
//                       style={{
//                         position: "absolute",
//                         right: "25px"
//                       }}
//                     >
//                       <i class="fas fa-times"
//                         style={{
//                           color: "#ff0000",
//                           cursor: "pointer",
//                           fontSize: "1em"
//                         }}
//                         onClick={() => removeProducts(index)}
//                       ></i>
//                     </div>
//                   ) : null}

//                 </div>

//               ))}
//             </div>

//           </div>
//           <div className=" d-flex justify-content-end">
//             {
//               currentStep > 2 &&
//               <button
//                 type="button"
//                 className="btn mt-3"
//                 style={{
//                   background: "rgb(133, 218, 79)",
//                   borderRadius: "13px",
//                   marginRight: "15px"
//                 }}
//                 onClick={(e) => handleBack(e)}
//               >Back
//               </button>
//             }

//             <button
//               disabled={formDataLoading}
//               type="submit"
//               className="btn mt-3"
//               style={{
//                 background: "rgb(133, 218, 79)",
//                 borderRadius: "13px",
//               }}
//             >
//               {formDataLoading
//                 ? "Saving..."
//                 // : "Add College/University"
//                 : `Save & Continue`
//               }
//             </button>
//           </div>
//         </form>
//       </section>

//     </>
//   );
// };

// export default CollegeUniversityStep3;

import React, { useEffect, useState } from "react";
import {
  addOverviewCourse,
  getCourseCategories,
  getCourses,
  getOverviewCourses,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";

const CollegeUniversityStep3 = ({
  data,
  setData,
  setCurrentStep,
  currentStep,
}) => {
  const [formData, setFormData] = useState({
    collegeId: data?._id || "",
    overviewCourse: [],
  });

  const [formDataLoading, setFormDataLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [courseList, setCourseList] = useState([]); // array of arrays per row
  const [items, setItems] = useState([
    { courseCategory: "", courseDegree: "", eligibilityCriteria: "" },
  ]);

  // 🟢 fetch categories
  const fetchCourseCategories = async () => {
    try {
      const res = await getCourseCategories();
      if (res?.status) {
        setCourseCategories(res?.data);
      } else {
        toast.error("Error while Fetching Course Categories Data");
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
    }
  };

  // 🟢 fetch courses by category
  const fetchCourses = async (categoryId) => {
    try {
      const res = await getCourses();
      if (res?.status) {
        return res?.data.filter((item) => item.categoryId === categoryId);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
    }
    return [];
  };

  // 🟢 fetch overview courses (auto-fill)
  const fetchOverviewCourses = async (collegeId) => {
    try {
      const res = await getOverviewCourses(collegeId);
      if (res?.status && res?.data?.overviewCourse?.length) {
        const formatted = res?.data?.overviewCourse?.map((item) => ({
          courseCategory: item?.courseCategory?._id || "",
          courseDegree: item?.courseDegree?._id || "",
          eligibilityCriteria: item?.eligibilityCriteria || "",
        }));

        // populate courseList for each row
        const courseOptionsArr = await Promise.all(
          formatted.map((item) =>
            item.courseCategory ? fetchCourses(item.courseCategory) : []
          )
        );

        setCourseList(courseOptionsArr);
        setItems(formatted);
        setFormData({ collegeId, overviewCourse: formatted });
      } else {
        // no data → keep initial empty row
        setItems([
          { courseCategory: "", courseDegree: "", eligibilityCriteria: "" },
        ]);
        setCourseList([[]]);
      }
    } catch (error) {
      toast.error("Failed to fetch overview courses");
      console.error(error);
    }
  };

  // 🟢 handle change
  const handleMultiChange = async (i, e) => {
    const { name, value } = e.target;
    let newFormValues = [...items];
    newFormValues[i][name] = value;
    setItems(newFormValues);
    setFormData((prev) => ({ ...prev, overviewCourse: newFormValues }));

    if (name === "courseCategory") {
      const courseOptions = await fetchCourses(value);
      setCourseList((prev) => {
        const updated = [...prev];
        updated[i] = courseOptions;
        return updated;
      });
      // reset courseDegree when category changes
      newFormValues[i]["courseDegree"] = "";
      setItems(newFormValues);
      setFormData((prev) => ({ ...prev, overviewCourse: newFormValues }));
    }
  };

  // 🟢 add/remove
  const addItem = () => {
    setItems([
      ...items,
      { courseCategory: "", courseDegree: "", eligibilityCriteria: "" },
    ]);
    setCourseList([...courseList, []]);
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);

    let newCourseList = [...courseList];
    newCourseList.splice(i, 1);

    setItems(newFormValues);
    setCourseList(newCourseList);
    setFormData((prev) => ({ ...prev, overviewCourse: newFormValues }));
  };

  // 🟢 submit
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setFormDataLoading(true);
      const res = await addOverviewCourse(formData);
      if (res?.status) {
        toast.success("Saved successfully!");
        setData((prev) => ({
          ...prev,
          overviewCourse: formData.overviewCourse,
        }));
        setCurrentStep(currentStep + 1);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error("Failed to save");
    } finally {
      setFormDataLoading(false);
    }
  };

  // 🟢 effects
  useEffect(() => {
    fetchCourseCategories();
    if (data?._id) fetchOverviewCourses(data._id);
  }, [data?._id]);

  return (
    <section className="chartBox_area">
      <form onSubmit={handleUpdate}>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12 mt-3">
            <label>
              Eligibility{" "}
              <button
                className="btn btn-sm btn-success"
                type="button"
                onClick={addItem}
              >
                <i className="fas fa-plus"></i> Add Course
              </button>
            </label>

            {items.map((element, index) => (
              <div className="_form-inline row" key={index}>
                <div className="col-md-2 mb-2 mt-1">
                  <label>Category:</label>
                  <select
                    name="courseCategory"
                    onChange={(e) => handleMultiChange(index, e)}
                    value={element?.courseCategory}
                    className="form-control"
                  >
                    <option value="">--- Choose ---</option>
                    {courseCategories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3 mb-2 mt-1">
                  <label>Course:</label>
                  <select
                    name="courseDegree"
                    onChange={(e) => handleMultiChange(index, e)}
                    value={element?.courseDegree}
                    className="form-control"
                  >
                    <option value="">--- Choose ---</option>
                    {courseList[index]?.map((course) => (
                      <option key={course._id} value={course._id}>
                        {course.degreeName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-7 mb-2 mt-1">
                  <label>Eligibility:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="eligibilityCriteria"
                    placeholder="Eligibility criteria"
                    value={element.eligibilityCriteria || ""}
                    onChange={(e) => handleMultiChange(index, e)}
                  />
                </div>

                {index ? (
                  <div style={{ position: "absolute", right: "25px" }}>
                    <i
                      className="fas fa-times"
                      style={{
                        color: "#ff0000",
                        cursor: "pointer",
                        fontSize: "1em",
                      }}
                      onClick={() => removeProducts(index)}
                    ></i>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>

        <div className=" d-flex justify-content-end">
          {currentStep > 2 && (
            <button
              type="button"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
                marginRight: "15px",
              }}
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              Back
            </button>
          )}

          <button
            disabled={formDataLoading}
            type="submit"
            className="btn mt-3"
            style={{
              background: "rgb(133, 218, 79)",
              borderRadius: "13px",
            }}
          >
            {formDataLoading ? "Saving..." : "Save & Continue"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default CollegeUniversityStep3;
